module.exports = __webpack_public_path__ + "static/assets/96b213d926b7895878e1a1a693cb1053.png";